import { apiUrl } from '../utils/constants';
import { DELETE, GET, POST, PUT } from './api.service.wrapper';



export const GetCountry = async (keyword = '', page = '', perPage = '', is_paginate = 1, status = null, ) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }


    if (keyword) {
        params['name'] = keyword;
    }

    if (status) {
        params['status'] = status;
    }

    if(is_paginate==1){
        params['paginate'] = is_paginate;
    }
    const response = await GET(apiUrl.countries, params);
    return response;
}

export const GetCountryById = async (id) => {
    let params = {};
    let response = '';
    response = await GET(apiUrl.countries + '/' + id,params);
    return response;
}

export const CreateCountry = async (data) => {
    const response = await POST(apiUrl.countries, data);
    return response;
}

export const UpdateCountry = async (id, data) => {
    const response = await PUT(apiUrl.countries, id, data);
    return response;
}

export const DeleteCountry = async (id) => {
    const response = await DELETE(apiUrl.countries, id);
    return response;
}
